import { db } from '../firebase';
import { DEFAULT_SUBSCRIPTION_PLANS, DEFAULT_FLEX_CREDIT_PACKAGES, DEFAULT_TOOL_DESCRIPTIONS } from './subscriptionDefaults';
import { getPublicSubscriptionPlans, getPublicFlexCreditPackages, getPublicToolDescriptions } from './publicDataService';

// Variable to store cached data that can be updated by authenticated users
let cachedSubscriptionPlans = null;
let cachedFlexCreditPackages = null;
let cachedToolDescriptions = null;
let cachedSalesData = null;

/**
 * Fetches subscription plans for the landing page
 */
export async function getLandingPageSubscriptionPlans() {
  try {
    // Return cached data if available
    if (cachedSubscriptionPlans && cachedSalesData) {
      return { 
        plans: cachedSubscriptionPlans, 
        activeSales: cachedSalesData 
      };
    }
    
    // Otherwise fetch from Firebase using publicDataService
    return await getPublicSubscriptionPlans();
  } catch (error) {
    console.error('Error fetching landing page subscription plans:', error);
    return { 
      plans: DEFAULT_SUBSCRIPTION_PLANS, 
      activeSales: {
        subscription: { active: false, name: '', percentage: 0 }
      }
    };
  }
}

/**
 * Fetches flex credit packages for the landing page
 */
export async function getLandingPageFlexCreditPackages() {
  try {
    // Return cached data if available
    if (cachedFlexCreditPackages && cachedSalesData) {
      return { 
        packages: cachedFlexCreditPackages, 
        activeSales: cachedSalesData 
      };
    }
    
    // Otherwise fetch from Firebase using publicDataService
    return await getPublicFlexCreditPackages();
  } catch (error) {
    console.error('Error fetching landing page flex credit packages:', error);
    return { 
      packages: DEFAULT_FLEX_CREDIT_PACKAGES,
      activeSales: {
        flexCredits: { active: false, name: '', percentage: 0 }
      }
    };
  }
}

/**
 * Fetches tool descriptions for the landing page
 */
export async function getLandingPageToolDescriptions() {
  try {
    // Return cached data if available
    if (cachedToolDescriptions) {
      return cachedToolDescriptions;
    }
    
    // Otherwise fetch from Firebase using publicDataService
    return await getPublicToolDescriptions();
  } catch (error) {
    console.error('Error fetching landing page tool descriptions:', error);
    return DEFAULT_TOOL_DESCRIPTIONS;
  }
}

/**
 * Updates the cached data when an authenticated user fetches the latest data
 * This function should be called from the authenticated pages
 */
export function updateLandingPageCache(subscriptionPlans, flexCreditPackages, toolDescriptions, salesData) {
  if (subscriptionPlans) cachedSubscriptionPlans = subscriptionPlans;
  if (flexCreditPackages) cachedFlexCreditPackages = flexCreditPackages;
  if (toolDescriptions) cachedToolDescriptions = toolDescriptions;
  if (salesData) cachedSalesData = salesData;
  
  console.log('Landing page cache updated with authenticated data');
}
